import { useSessaoCapturaCtx } from '../../contexts/SessaoCapturaContext'

function fmtTime(s: number): string {
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`
  return `${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`
}

const CTX_LABEL: Record<string, string> = { OBRA: 'Obra', REUNIAO: 'Reunião', LIVRE: 'Livre' }

const SEP = () => (
  <span style={{ width: 1, height: 12, background: 'rgba(255,255,255,0.10)', display: 'block', flexShrink: 0 }} />
)

export default function CapturaBar() {
  const { sessao, seconds, expanded, expand } = useSessaoCapturaCtx()
  if (!sessao || expanded) return null

  const label = sessao.titulo ?? CTX_LABEL[sessao.contexto] ?? 'Captura'

  return (
    <div
      className="fixed z-[250] flex items-center gap-3 cursor-pointer"
      style={{
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '8px 8px 8px 16px',
        borderRadius: 100,
        background: 'rgba(12,12,12,0.85)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid rgba(255,255,255,0.10)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)',
        whiteSpace: 'nowrap',
      }}
      onClick={expand}
    >
      {/* Indicador pulsante */}
      <div className="flex items-center gap-1.5">
        <span
          className="w-1.5 h-1.5 rounded-full animate-pulse shrink-0"
          style={{ background: 'var(--color-vermelho)' }}
        />
        <span className="text-[9px] tracking-[0.10em] uppercase font-bold"
          style={{ color: 'var(--color-vermelho)' }}>
          Captura
        </span>
      </div>

      <SEP />

      {/* Label */}
      <span className="text-[12px] text-[#bbb] max-w-[160px] truncate">{label}</span>

      {/* Timer */}
      <span className="text-[13px] font-light text-[#f0f0f0] [font-variant-numeric:tabular-nums]">
        {fmtTime(seconds)}
      </span>

      <SEP />

      {/* Abrir */}
      <button
        onClick={(e: React.MouseEvent) => { e.stopPropagation(); expand() }}
        className="flex items-center gap-1 px-3 py-1.5 rounded-full text-[10px] font-semibold uppercase tracking-[0.06em] cursor-pointer border-none transition-colors"
        style={{ background: 'rgba(196,212,74,0.15)', color: 'var(--color-hero)' }}
        aria-label="Abrir sessão de captura"
      >
        <span className="material-symbols-outlined text-xs">open_in_full</span>
        Abrir
      </button>
    </div>
  )
}
